import { Stack, Text } from '@mantine/core';
import { FC } from 'react';

export const StackedValuesCell: FC<{ values: string[] }> = ({ values }) => (
  <Stack gap={0}>
    {values.map((value, index) => (
      <Text key={index} size="sm">
        {value}
      </Text>
    ))}
  </Stack>
);

export const StackedLabelsCell: FC<{ labels: readonly string[] }> = ({
  labels,
}) => (
  <Stack gap={0}>
    {labels.map((label, index) => (
      <Text c="dimmed" fw={500} key={index} size="sm">
        {label}
      </Text>
    ))}
  </Stack>
);
